import type React from 'react';
import DetailsView from '@/components/Templates/DetailsView';
import type { SupportTicketDetailsResponse } from '@/types/supportTicket';
import { extractDocumentName, mapPriority, mapStatus, mapType } from '../constants';
import { buildDocumentsUrl } from '@/utils/navigationItems';

interface SupportTicketDetailsProps {
	data: SupportTicketDetailsResponse | null;
	isLoading?: boolean;
	onRemoveDocument?: (documentId: string) => void;
}

const SupportTicketDetails: React.FC<SupportTicketDetailsProps> = ({
	data,
	isLoading = false,
}) => {
	if (!data) {
		return (
			<DetailsView
				data={[]}
				isLoading={isLoading}
				gridConfig={{ base: '1fr', md: 'repeat(2, 1fr)' }}
			/>
		);
	}

	// Map the backend data to display values
	const priority = mapPriority(data.prioritycode);
	const status = mapStatus(data.statuscode);
	const type = mapType(data.casetypecode);
	const documentName = extractDocumentName(data.ta_documentupload);
	const documentUrl = data.ta_documentupload && documentName !== '---' && data?.customer?.accountid && data?.customer?.name ?
		buildDocumentsUrl(data.ta_documentupload, data?.customer?.accountid, data?.customer?.name) : '';

	return (
		<DetailsView
			isLoading={isLoading}
			gridConfig={{ base: '1fr', md: 'repeat(2, 1fr)' }}
			data={[
				{
					data: [
						{ label: 'Subject', value: data.title || '-' },
						{ label: 'Priority', value: priority.label },
						{ label: 'Practice', value: data.customerName || '-' },
						{ label: 'Status', value: status.label },

					],
				},
				{
					data: [
						{ label: 'Type', value: type || '-' },
						{ label: 'Description', value: data.description || '-' },
						{
							label: 'Documents',
							value: documentName !== '---' ? documentName : '-',
							navigateTo: documentUrl || '',
						},
					],
				},
			]}
		/>
	);
};

export default SupportTicketDetails;
